import script from "./PartnerDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerDashboard.vue?vue&type=script&setup=true&lang=js"

import "./PartnerDashboard.vue?vue&type=style&index=0&id=5b123a60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b123a60"]])

export default __exports__